class Accordion extends HTMLElement {
  constructor() {
    super();
    const accordions = this.getElementsByClassName('accordion');

    for (let i = 0; i < accordions.length; i++) {
      accordions[i].addEventListener('click', function () {
        this.classList.toggle('active');
        const panel = this.nextElementSibling;
        panel.classList.toggle('active');
        this.setAttribute('aria-expanded', this.classList.contains('active'));
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = Number(panel.scrollHeight) + 100 + '%';
        }
      });
    }
  }
}

customElements.define('accordion-info', Accordion);
